var m = require('mithril');
var prop = require('mithril/stream');
var moment = require('moment');
var loaders = require('../layout/components/loaders');
var button = require('../components/button');
var heading = require('../components/heading');
var formGroup = require('../components/formGroup');
var ToggleSwitch = require('../components/toggleSwitch');
var dragscroll = require('../libs/dragscroll');
var pathHeader = require('../layout/components/pathHeader');
var pageRequestState = require('../layout/components/pageRequestState');
var dateFormat = 'MM/DD/YYYY';

var inspection = {};

inspection.oninit = function () {
  var ctrl = this;
  ctrl.comment = prop('');
  pageRequestState.initialize(ctrl);
  ctrl.init = function () {
    var url = '/api/v1/equipment/' + m.route.param('id');
    ctrl.equipmentRecord = undefined;
    return pageRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: url,
        method: 'GET'
      })
      .then(function (result) {
        if (!result || !Array.isArray(result.path)) {
          throw new Error('Equipment response is missing its location path.');
        }

        if (result.path[0] && !result.path[0].name) {
          result.path[0].name = result.path[0]['@class'];
          result.name = result.path[0]['@class'];
        }

        ctrl.equipmentRecord = result;
        ctrl.equipmentRecord.path.reverse();
        ctrl.fakePath = {'@rid': 1, 'name': 'Inspections'};
        ctrl.equipmentRecord.path.push(ctrl.fakePath);
      });
    }, { errorMessage: 'Unable to load inspections:' })
    .then(function (result) {
      m.redraw();
      return result;
    });
  };
  return ctrl.init();

  ctrl.save = ()=>{
    let data = {
      record: ctrl.equipmentRecord,
      damage: document.getElementById('damage').checked,
      noises: document.getElementById('noises').checked,
      lamp_test: document.getElementById('lamp_test').checked,
      comment: ctrl.comment()
    }
    return loaders.requestWithLoader({
      loader: 'submit',
      url: '/api/v1/inspection',
      method: 'POST',
      body: data
    })
    .then(function (response) {
      document.getElementById('damage').checked = false;
      document.getElementById('noises').checked = false;
      document.getElementById('lamp_test').checked = false;
      ctrl.comment('')
      ctrl.init();
    })
  }
};

inspection.view = function (ctrl) {
  var ctrl = this;
  var stateView = pageRequestState.view(ctrl);
  if (stateView) return stateView;
  if(!ctrl.equipmentRecord){
    return m('div');
  }
  return m('div.mh3.mv3', [
    m(pathHeader, {
      ancestors: ctrl.equipmentRecord.path, 
      record: ctrl.fakePath,
    }),
    m(heading,{label:'List of Inspections', class:'f-subheadline fw2 mb3 pb1 isotope'}),
    m('div.mv1.pb5', [
      m('div.dragscroll-container', [
        m('div.dragscroll', {oncreate:dragscroll}, [
          m('table.fw2.f3.w-100.pr3', [
            m('thead', [
              m('tr.relative', [
                m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {width: '20%'}},'Date'),
                m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {width: '20%'}},'Comment'),
                m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {width: '20%'}},'Visible Damage'),
                m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {width: '20%'}},'Unusual Noises'),
                m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', {style: {width: '20%'}},'Lamp Test Pass')
              ])
            ]),
            m('tbody', [
              (ctrl.equipmentRecord.in_performedOn || []).map(function (inspectionRecord) {
                return m('tr', [
                  m('td.bb.tl.moon-gray.tl.nowrap', moment(parseInt(inspectionRecord.out.date)).format(dateFormat)),
                  m('td.bb.tl.moon-gray.tl.nowrap', inspectionRecord.out.comment),
                  m('td.bb.tl.moon-gray.tl.nowrap', inspectionRecord.out.damage.toString()),
                  m('td.bb.tl.moon-gray.tl.nowrap', inspectionRecord.out.noises.toString()),
                  m('td.bb.tl.moon-gray.tl.nowrap', inspectionRecord.out.lamp_test.toString()),
                ])
              })
            ])
          ])
        ])
      ]),
    ]),
    m(formGroup, {class:'flex justify-between pv3 bb'}, [
      m('label', `Is there an visible damage on the ${ctrl.equipmentRecord['@class']}?`),
      m(ToggleSwitch, {
        id: 'damage',
        ariaLabel: 'Visible damage'
      })
    ]),
    m(formGroup, {class:'flex justify-between pv3 bb'}, [
      m('label', `Is the ${ctrl.equipmentRecord['@class']} making any unusual noises?`),
      m(ToggleSwitch, {
        id: 'noises',
        ariaLabel: 'Unusual noises'
      })
    ]),
    m(formGroup, {class:'flex justify-between pv3 bb'}, [
      m('label', 'Did the Lamp Test pass?'),
      m(ToggleSwitch, {
        id: 'lamp_test',
        ariaLabel: 'Lamp test pass'
      })
    ]),
    m(formGroup, {class:'flex justify-between pv3 bb'}, [
      m('div.w-100.flex justify-between',[ 
        m('label', 'Additional Notes')
      ]),
      m('div.w-100.flex justify-between',[ 
        m('textarea.w-100', {
          resize: 'none',
          id:'comment',
          rows:'3',
          cols:'40', 
          'box-sizing': 'border-box',
          placeholder:"Add your note here...",
          oninput: function(ev){ctrl.comment(ev.target.value)},
          value: ctrl.comment()
        })
      ]),
    ]),
    m('div.flex.justify-between', [
      m(formGroup, {class:'flex justify-center pv3'}, [
        m(button, {
          label: 'Save',
          func: ()=>{ ctrl.save(); },
          class: 'w5 blue'
        })
      ])
    ])
  ])
};


module.exports = inspection;
